
<!-- Note:  To use FilterBar, ensure that prop: 'filters' is set as a DATA or COMPUTED
            variable - setting it inline with the HTML will lead to unexpected behavior -->


<template>

	<div class="container-fluid">

		<div class="d-flex justify-content-center">

			<slot name="before"></slot>

			<template v-for="filter in filters">

				<!----- Past Week/Month/6Months/Year/AllTime/Custom ----->
				<template v-if="'type' in filter && filter.type == 'date'">

					<field
						class="date-selector-field"
						:class="filter.value != 'custom' ? 'mr-4' : 'mr-2'"
						:label="'label' in filter && filter.label ? filter.label : 'Date'"
						col-class="col-auto"
						:params="{
							type:'select',
							options: [
								{text:'Past Week', value:'week'},
								{text:'Past Month', value:'month'},
								{text:'Past Six Months', value:'six-months'},
								{text:'Past Year', value:'year'},
								{text:'All-Time', value:'all'},
								{text:'Custom Range', value:'custom'}
							],
						}"
						v-model="filter.value"
						v-on:change="changeDateRange(filter, $event)">
					</field>

				</template>


				<!----- Custom Date Range ----->
				<template v-if="'type' in filter && filter.type == 'date' && 'value' in filter && filter.value == 'custom'">

					<field
						class="custom-date-range-field"
						label=""
						col-class="col-auto"
						:params="{ type:'date' }"
						v-model="filter.startDate"
						v-on:change="generateFilters">
					</field>

					<h5 class="col-form-label mx-2"> to </h5>

					<field
						class="custom-date-range-field mr-5"
						label=""
						col-class="col-auto"
						:params="{ type:'date' }"
						v-model="filter.endDate"
						v-on:change="generateFilters">
					</field>

				</template>

				<!----- Text Input ----->
				<template v-if="'type' in filter && filter.type == 'text'">

					<field
						class="mr-4"
						:label="'label' in filter && filter.label ? filter.label : 'Date'"
						col-class="col-auto"
						:params="{
							type:'text',
							placeholder: 'placeholder' in filter && filter.placeholder ? filter.placeholder : ''
						}"
						v-model="filter.value"
						v-on:change="generateFilters">
					</field>

				</template>


				<!----- Select Input ----->
				<template v-if="'type' in filter && filter.type == 'select'">

					<field
						class="mr-4"
						:label="'label' in filter && filter.label ? filter.label : ''"
						col-class="col-auto"
						:params="{ type:'select', options: filter.options }"
						v-model="filter.value"
						v-on:change="generateFilters">
					</field>

				</template>



			</template>

			<!-- Slot for any other additions (eg. a "Compare By" button group) -->
			<slot name="inline"></slot>

		</div>


		<div class="d-flex justify-content-center">

			<!----- Render LAST on new lines ----->
			<template v-for="filter in filters">

				<!----- Multi-Select Input ----->
				<template v-if="'type' in filter && filter.type == 'select-multi'">

					<field
						class="mr-4 mt-3"
						:label="'label' in filter && filter.label ? filter.label : 'Date'"
						col-class="col-auto"
						:params="{ type:'select-multi', options: filter.options }"
						v-model="filter.value"
						v-on:change="generateFilters">
					</field>

				</template>

			</template>
		</div>

		<div class="d-flex justify-content-center">
			<slot name="after"></slot>
		</div>

	</div>

</template>

<script type="text/javascript">

import Field from "@/components/Field"

export default {
	name: 'FilterBar',
	props: [
		/*
		filters is a list of filters, where each has the following properties:
			label - display name of filter
			type - type of filter
				'daterange' - a range of dates (start and end)
				'text' - a text input
		 */
		"filters"
	],
	components: {
		Field
	},
	data () {
		return {
		}
	},
	watch: {
		filters() {
			// One of the provided filters changes? Reset all filters & emit
			this.initializeFilters()
		}
	},

	computed: {

	},

	methods: {

		changeDateRange(filter, value, emitFilters=true) {

			filter.value = value
			filter.endDate = this.moment().format("YYYY-MM-DD")

			let now = this.moment()

			if (value == 'week') {
				filter.startDate = now.subtract(1, 'week')
			} else if (value == 'month') {
				filter.startDate = now.subtract(1, 'month')
			} else if (value == 'six-months') {
				filter.startDate = now.subtract(6, 'month')
			} else if (value == 'year') {
				filter.startDate = now.subtract(1, 'year')
			} else if (value == 'all') {
				filter.startDate = ""
			} else {
				filter.startDate = null
				filter.endDate = null
			}

			if (filter.startDate)
				filter.startDate = filter.startDate.format("YYYY-MM-DD")

			if (emitFilters)
				this.generateFilters()

		},

		generateFilters() {
			// Generates a boolean function to be used by .filter on an object array
			// Emits the filter as 'filterChange'

			let vm = this
			let fullFilters = []

			this.$nextTick(() => {

				vm.filters.forEach(filter => {

					// Date
					if (filter.type == "date") {

						if (filter.startDate !== null)
							fullFilters.push([filter.prop + ' >', filter.startDate])
						if (filter.endDate)
							fullFilters.push([filter.prop + ' <=', filter.endDate])
					}

					if (filter.type == "text") {
						if (filter.value)
							fullFilters.push([filter.prop, filter.value])
					}

					if (filter.type == 'select-multi') {
						if (filter.value.length)
							fullFilters.push([filter.prop, filter.value])
					}

					if (filter.type == 'select') {
						if (filter.value)
							fullFilters.push([filter.prop, filter.value])
					}
				})

				vm.$forceUpdate()
				vm.$emit('filterChange', fullFilters)
			})
		},

		initializeFilters() {
			this.filters.forEach(filter => {

				if (filter.type == 'date') {

					// Label, type, prop already set
					if ('initialDateRange' in filter && filter.initialDateRange)
						this.changeDateRange(filter, filter.initialDateRange, false)
					else
						this.changeDateRange(filter, 'month', false)
				}

				if (filter.type == 'select-multi') {
					if (!('value' in filter)) filter.value = []
				}

				if (filter.type == 'select') {
					if (!('value' in filter)) filter.value = ""
				}
			})
			this.generateFilters()
		}
	},

	created() {
		this.initializeFilters()
	}

}
</script>


<style type="text/css">

	.filter-field {

	}

	.custom-date-range-field {
		width: 130px;
	}

	.col-form-label {
		text-align: left;
		font-weight: 600;
	}

	@media (max-width: 500px) {
		.date-selector-field {
			width: 100%;
		}
		.custom-date-range-field {
			width: 100%;
		}
		filter-field {
			width: 100%
		}
	}

</style>